// extracted by mini-css-extract-plugin
export default {"ListWrapper":"zcuZKWJNQG9sdTxbSyML","TabList":"QqfABz0jv7crGhqvIJlQ","TabContent":"VphcdOhVwpXxhvvPmAiw","Card":"lPTNRKMIaRtTkcBpsbyw","CardContent":"ltzsAOJkolz790xTYqeY"};